import Vue from 'vue';
import Vuex from 'vuex';
import datas from '../datas/form';

Vue.use(Vuex);

const state = {
  data: {
    'steps': [],
    'extra': {},
    'meta': {},
    'styles': {},
  },
};

const getters = {
  steps(state) {
    return state.data.steps;
  },
  extra(state) {
    return state.data.extra;
  },
  styles(state) {
    return state.data.styles;
  },
  meta(state) {
    return state.data.meta;
  },
};

const actions = {
  initData: ({commit}) => {
    commit('SET_DATA', datas);
  },
};

const mutations = {
  SET_DATA: (state, data) => {
    state.data = data;
  },
};

const Store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});

export default Store;